export default function capitalizeWords(words: string) {
  return words.replace(/\b\w/g, (l) => l.toUpperCase()) || '';
}
